export const SubNavSettingsCog = require('./SubNavSettingsCog.png');
export const ExampleImage = require('./exampleImage.png');
export const SearchBarIcon = require('./searchBarIcon.png');
export const CommentInput_RECORD = require('./CommentInput_RECORD.png');
export const CommentInput_TEXT = require('./CommentInput_TYPE.png');
export const NoProfileImageUrl = require('./no_profile_img.png');

export const DropDownArrow = require('./DropDownArrow.png');
export const FadedGreyXButton = require('./fadedGreyXButton.png');
export const LargeXFamilyMemberProfile = require('./LargeXFamilyMemberProfile.png');
export const SmallRedTagXButton = require('./SmallRedTagXButton.png');
export const UploadArtifactPromptImage = require('./UploadArtifactPromptImage.png');
export const WhiteXButton = require('./whiteXButton.png');
export const BlueBackArrow = require('./BlueBackArrow.png');
export const WhiteArrowLeft = require('./WhiteArrowLeft.png');
export const WhiteArrowRight = require('./WhiteArrowRight.png');

export const StopButton = require('./StopButton.png');
export const PlayButton = require('./PlayButton.png');
export const PauseButtonIcon = require('./PauseButton.png');
export const InputPadlock = require('./input_padlock.png');
export const InputUser = require('./input_user.png');
export const InputEmail = require('./input_email.png');
export const Checkmark = require('./checkmark.png');
export const DropDownArrowWhite = require('./DropDownArrowWhite.png');
export const LoginBackground = require('./bg-auth-pages.jpg');
export const SmallGreenRightArrow = require('./SmallGreenRightArrow.png');

export const EmptyCheckBox = require('./EmptyCheckBox.png');
export const CheckedBox = require('./CheckedBox.png');

export const GroupImageIcon = require('./GroupImageIcon.png');
export const FamiliesIcon = require('./FamiliesIcon.png');
export const UploadPhotoIcon = require('./UploadPhotoIcon.png');
export const AudioCommentIcon = require('./AudioCommentIcon.png');
export const CheckMarkCircleIcon = require('./CheckMarkCircleIcon.svg');
export const TightKnitLogoWhite = require('./TightKnitLogoWhite.svg');
export const NotificationButtonIcon = require('./NotificationButtonIcon.svg');
export const NameButtonIcon = require('./NameButtonIcon.svg');
export const ModalXIcon = require('./ModalXIcon.png');

export const NotificationTopBar = require('./NotificationTopBar.png');
export const NotificationPhotoIcon = require('./NotificationPhotoIcon.png');
export const NotificationCommentIcon = require('./NotificationCommentIcon.png');
export const NotificationRecordingIcon = require('./NotificationRecordingIcon.png');
export const NotificationFamilyIcon = require('./NotificationFamilyIcon.png');
export const NotificationStoryIcon = require('./NotificationStoryIcon.png');

export const TEST_IMAGE_HORIZONTAL = require('./TEST_IMAGE_HORIZONTAL.png');
export const TEST_IMAGE_VERTICAL = require('./TEST_IMAGE_VERTICAL.png');
export const ModalXIconDark = require('./ModalXIconDark.png');
export const ModalXIconInverse = require('./ModalXIconInverse.png');

export const RightPhotoArrow = require('./RightPhotoArrow.png');
export const LeftPhotoArrow = require('./LeftPhotoArrow.png');

export const EmptyProfileImage = require('./EmptyProfileImage.png');
export const TightKnitLogoBrown = require('./TightKnitLogoBrown.svg');

export const PadLock = require('./PadLock.png');
export const PlaceholderStoryImage = require('./PlaceholderStoryImage.png');
export const WhitePadLock = require('./WhitePadLock.png');

export const LinkArrow = require('./LinkRight.png');
export const InviteIcon = require('./InviteIcon.png');

export const LoginSideImage = require('./LoginSideImage.png');
export const LearnMoreButton = require('./LearnMoreButton.svg');
export const TakeATourButton = require('./TakeATourButton.svg');
export const LoginSideHeader = require('./LoginSideHeader.svg');
export const SupportButtonIcon = require('./SupportButtonIcon.svg');

export const HelloNewFriendHeader = require('./HelloNewFriendHeader.svg');
export const WelcomeBackHeader = require('./WelcomeBackHeader.svg');
export const WelcomeImage = require('./WelcomeImage2020.png');
export const InfoIcon = require('./information.svg');



// WEBPACK FOOTER //
// ./src/images/images.ts